import {allConfigs} from './allConfigs';
import {generateFeatureBranchConfig} from './getHostConfigByHostname_UNSAFE';
import {Locale} from './locale';

export function getLocaleByHostname(hostname: string): Locale | undefined {
  const urlConfig = allConfigs.find(environment =>
    environment.urlSets.some(urlSet => urlSet.hostname === hostname),
  );

  if (!urlConfig) {
    const featureBranchConfig = generateFeatureBranchConfig(hostname);
    if (featureBranchConfig.urlConfig?.locale) {
      return featureBranchConfig.urlConfig.locale;
    } else {
      return undefined;
    }
  }

  return urlConfig.locale;
}
